module.exports = __webpack_public_path__ + "img/exampleImg.5ff48bfe.png";